interface UserAgentRule {
  name: string
  pattern: RegExp
}

const BROWSER_RULES: UserAgentRule[] = [
  { name: 'Edge', pattern: /Edg(?:e|A|iOS)?\/(\d+)/ },
  { name: 'Opera', pattern: /OPR\/(\d+)/ },
  { name: 'Samsung Internet', pattern: /SamsungBrowser\/(\d+)/ },
  { name: 'Firefox', pattern: /(?:Firefox|FxiOS)\/(\d+)/ },
  { name: 'Chrome', pattern: /(?:Chrome|CriOS)\/(\d+)/ },
  { name: 'Safari', pattern: /Version\/(\d+)[\d.]* .*Safari/ },
]

const OS_RULES: UserAgentRule[] = [
  { name: 'iOS', pattern: /iPhone|iPad|iPod/ },
  { name: 'Android', pattern: /Android/ },
  { name: 'Windows', pattern: /Windows NT/ },
  { name: 'ChromeOS', pattern: /CrOS/ },
  { name: 'macOS', pattern: /Mac OS X/ },
  { name: 'Linux', pattern: /Linux/ },
]

export const detectBrowser = (userAgent: string): string | null => {
  const matched = BROWSER_RULES
    .map(({ name, pattern }) => ({ name, version: userAgent.match(pattern)?.[1] }))
    .find(({ version }) => version !== undefined)

  return matched ? `${matched.name} ${matched.version}` : null
}

export const detectOs = (userAgent: string): string | null =>
  OS_RULES.find(({ pattern }) => pattern.test(userAgent))?.name ?? null
